<script>
  import { createEventDispatcher } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'
  import { portal } from '../utils.js'
  import Close from '../Close/index.js'
  import { Form } from '../FormElements/index.js'
  import { Flex, FlexItem } from '../Flex/index.js'

  export let active = false
  export let title = null

  const dispatch = createEventDispatcher()

  export const open = () => {
    active = true
    document.documentElement.style.overflow = 'hidden'
  }
  export const close = () => {
    active = false
    document.documentElement.style.removeProperty('overflow')
    dispatch('close')
  }
</script>

<div use:portal={'body'} hidden>
  <div class={`${cssPrefix}inspector`} class:is-active={active}>
    <div class={`${cssPrefix}inspector-header`}>
      <Flex>
        <slot name="title" />

        {#if title}
          <div class={`${cssPrefix}inspector-header-title`}>
            <b class="gl-title level-5">{title}</b>
          </div>
        {/if}
        <FlexItem pushEnd>
          <Close on:close={() => close()} size={1.4} />
        </FlexItem>
      </Flex>
    </div>
    <div class={`${cssPrefix}horizontal-line`} />
    <div class={`${cssPrefix}inspector-main`}>
      <Form>
        <slot />
        <div class={`${cssPrefix}inspector-footer`}>
          <slot name="footer" />
        </div>
      </Form>
    </div>
  </div>
</div>
